import { Injectable } from "@angular/core";
import { LICENSES, MODULES, MODULES_BY_LICENSE } from "src/app/core/modules";

@Injectable()
export class LicenseService {
  private currentLicense: LICENSES = LICENSES.ESSENTIAL;

  set(license: LICENSES): void {
    this.currentLicense = license;
  }

  get(): LICENSES {
    return this.currentLicense;
  }

  async canBeActivated(module: MODULES): Promise<boolean> {
    const currentConfig = MODULES_BY_LICENSE[this.currentLicense];
    if (!currentConfig) {
      return false;
    }

    return currentConfig.includes(module);
  }

  canBeActivatedSync(module: MODULES): boolean {
    const currentConfig = MODULES_BY_LICENSE[this.currentLicense];
    if (!currentConfig) {
      return false;
    }

    return currentConfig.includes(module);
  }
}
